import reducer from './reducers';

export { default as Auth } from './containers';

export default reducer;
